import React, { Component } from 'react'
import { Modal, Button, Row, Col } from 'react-bootstrap'
import {reduxForm, Field} from 'redux-form'
import { required } from '../../util/validationFunctions'
import InputText from '../comun/form/InputText'
import InputCheckBox from '../comun/form/InputCheckBox'
import InputSelect from 'react-select'
import InputNumerical from '../comun/form/InputNumerical'
import InputTextArea from '../comun/form/InputTextArea'
import Dropzone from 'react-dropzone'
import { Unarchive } from '@material-ui/icons'
import './PedidosVenta.scss'

class ModalImportarPedidosCuartesa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      archivos: '',
      archivoCargado: false
    }
  }

  onDrop (archivos) {    
    archivos.map((archivo, i) => {
      var reader = new FileReader();
      reader.onloadend = () => {
        archivo.content=reader.result
        this.props.actions.subirArchivosImportarPedidosCuartesa({name: archivo.name, file: reader.result})
        this.setState({archivos: {name: archivo.name, file: reader.result}})
        this.setState({archivoCargado: true})
      }
      reader.readAsDataURL(archivo)
    })
  }

  submitImportarPedidosCuartesa () {
    this.props.actions.submitImportarPedidosCuartesa(this.state.archivos)
    this.setState({archivoCargado: false})
  }

  cerrarModalImportarPedidosCuartesa () {
    this.props.actions.cerrarModalImportarPedidosCuartesa()
    this.setState({archivos: ''})
    this.setState({archivoCargado: false})
  }

  descargarPlantillaExcelPedidosCuartesa () {
    this.props.actions.descargarPlantillaExcelPedidosCuartesa()
  }

  render () {
    const {
      t, handleSubmit, showModalImportarPedidosCuartesa, archivoPedidosCuartesa, listImportarPedidosCuartesa
      } = this.props

    if(!showModalImportarPedidosCuartesa) return null

    let errorImportar = listImportarPedidosCuartesa.filter(item => item.insertado===false)    
    let totalImportados = listImportarPedidosCuartesa.length;
    let totalErrores = errorImportar.length;
    let totalCorrectos = totalImportados - totalErrores;
    return (
      <Modal show={showModalImportarPedidosCuartesa} onHide={() => this.cerrarModalImportarPedidosCuartesa()} aria-labelledby="contained-modal-title-lg" backdrop="static" className="form-carga-index">
      <form>
        <Modal.Header closeButton>
          <Modal.Title>
          {t('IMPORTAR_PEDIDOS.TITLE')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <div className="archivos-carga-index">
              <Dropzone
                accept=".xls,.xlsx"
                onDrop={this.onDrop.bind(this)}
                uploadMultiple={true}
                maxFiles={null}
                // maxSize={200000}
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()}  className="custom-file-label">
                    <input {...getInputProps()} />
                    <label><span className="explorar-input-file">{t('COPIA_SEGURIDAD.SUBIR_ARCHIVO')}</span></label>
                  </div>
                )}
              </Dropzone>
            </div>
            {
              Object.keys(archivoPedidosCuartesa).length > 0 ? (
                <p className="nombre-archivo-subido"><Unarchive />{archivoPedidosCuartesa.name}</p>
              ) : null
            }
            {
              totalImportados > 0 && (
                <div className="resultado-importar-clientes">
                  <p>
                    <strong>{t('IMPORTAR_PEDIDOS_EXCEL.RESUMEN')}</strong><br />
                    {t('IMPORTAR_PEDIDOS_EXCEL.IMPORTADOS_CORRECTAMENTE', { correctos: totalCorrectos, total: totalImportados })}
                  </p>
                </div>
              )
            }            
            {
              Object.keys(errorImportar).length > 0 ? (
                <div className="resultado-importar-clientes error-importar">                  
                  <ul>      
                    <li><strong>{t('IMPORTAR_PEDIDOS_EXCEL.ERROR')}</strong></li>              
                    {
                      errorImportar.map((pedido, idx) => (
                        <li key={idx}>
                          <div>* <strong>{pedido.numeroPedido}</strong>{pedido.error ? ` - ${pedido.error}` : ''}</div>                                                  
                        </li>
                      ))
                    }
                  </ul>
                </div>
              ) : Object.keys(listImportarPedidosCuartesa).length > 0 ? (
                <div className="resultado-importar-pedidos">                
                  <ul>                                          
                    <li>{t('IMPORTAR_PEDIDOS_EXCEL.DOCUMENTO_SUBIDO')}</li>                      
                  </ul>                                      
                </div>
              ) : null
            }
          </Row>
        </Modal.Body>
        <Modal.Footer>          
          <Button type="button" onClick={() => this.descargarPlantillaExcelPedidosCuartesa()} className="btn btn-primary">{t('IMPORTAR_PEDIDOS_EXCEL.DESCARGAR_EJEMPLO_EXCEL')}</Button>
          {
            Object.keys(listImportarPedidosCuartesa).length === 0 ? (
              <Button type="button" onClick={() => this.submitImportarPedidosCuartesa()} className="btn btn-primary">{t('CARGA_INDEX.ACEPTAR')}</Button>
            ) : null
          }
          <Button type="button" className="btn btn-white" onClick={() => this.cerrarModalImportarPedidosCuartesa()}>{t('CARGA_INDEX.CANCELAR')}</Button>
        </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default (reduxForm({
  form: 'ModalImportarPedidosCuartesa',
})(ModalImportarPedidosCuartesa))